import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initI18n } from './i18n';

import "./index.css"

// Request fullscreen before React renders so window.innerHeight
// and safeAreaInset reflect the real fullscreen dimensions from the start
const twa = window?.Telegram?.WebApp;
const isMobilePlatform = twa && ['android', 'ios', 'android_x'].includes(twa.platform);
if (twa) {
  twa.expand();
  if (isMobilePlatform && typeof twa.requestFullscreen === 'function') {
    try { twa.requestFullscreen(); } catch (_) { /* unsupported */ }
  }
  // Свайп вниз больше не сворачивает/закрывает приложение (Bot API 7.7+).
  // Закрыть можно только кнопкой Close/свайпом за заголовок Telegram.
  if (twa.isVersionAtLeast?.('7.7') && typeof twa.disableVerticalSwipes === 'function') {
    try { twa.disableVerticalSwipes(); } catch (_) { /* unsupported */ }
  }
  // При закрытии Telegram показывает нативный диалог «Изменения могут не сохраниться» (Bot API 6.2+).
  if (twa.isVersionAtLeast?.('6.2') && typeof twa.enableClosingConfirmation === 'function') {
    try { twa.enableClosingConfirmation(); } catch (_) { /* unsupported */ }
  }
}

// env(safe-area-inset-top) can be 0 in Telegram's WKWebView even with viewport-fit=cover.
// safeAreaInset.top from the JS API becomes correct only AFTER fullscreen is established.
// We set --tg-safe-top-js immediately (may be 0) and then update it on Telegram events
// so all CSS using var(--tg-safe-top) reflows automatically once the value is known.
const updateSafeAreaFromJS = () => {
  const top = twa?.safeAreaInset?.top ?? 0;
  // contentSafeAreaInset.top = hardware notch + Telegram's own floating controls.
  // Use this for interactive elements (buttons) that must not be covered by Telegram UI.
  const contentTop = twa?.contentSafeAreaInset?.top ?? 0;
  document.documentElement.style.setProperty('--tg-safe-top-js', `${top}px`);
  document.documentElement.style.setProperty('--tg-content-safe-top-js', `${contentTop}px`);
};
updateSafeAreaFromJS();
twa?.onEvent?.('safeAreaChanged', updateSafeAreaFromJS);
twa?.onEvent?.('viewportChanged', updateSafeAreaFromJS);
twa?.onEvent?.('contentSafeAreaChanged', updateSafeAreaFromJS);

// Lock to portrait on mobile
if (isMobilePlatform && window.screen?.orientation?.lock) {
  window.screen.orientation.lock('portrait').catch(() => { /* unsupported */ });
}

// Английские дефолты из кода показываются сразу, файл языка с бэка подгружается параллельно авторизации
initI18n();

ReactDOM.createRoot(document.getElementById('root')).render(
  <div className="app-wrapper">
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </div>
);